import { render, staticRenderFns } from "./thirdPartyPolicy.vue?vue&type=template&id=4b65c9e4&scoped=true"
import script from "./thirdPartyPolicy.vue?vue&type=script&lang=js"
export * from "./thirdPartyPolicy.vue?vue&type=script&lang=js"
import style0 from "./thirdPartyPolicy.vue?vue&type=style&index=0&id=4b65c9e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b65c9e4",
  null
  
)

export default component.exports